// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import rootReducer from './rootReducer';
var store = configureStore({
    reducer: rootReducer,
});
export var useAppDispatch = function () { return useDispatch(); };
export default store;
